module.exports = __webpack_public_path__ + "img/success.49511620.svg";